import { render, staticRenderFns } from "./ProductsSelect.vue?vue&type=template&id=bbd046b8&scoped=true"
import script from "./ProductsSelect.vue?vue&type=script&lang=js"
export * from "./ProductsSelect.vue?vue&type=script&lang=js"
import style0 from "./ProductsSelect.vue?vue&type=style&index=0&id=bbd046b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd046b8",
  null
  
)

export default component.exports